import { render, staticRenderFns } from "./RamsSentPanel.vue?vue&type=template&id=6766fc7b&"
import script from "./RamsSentPanel.vue?vue&type=script&lang=js&"
export * from "./RamsSentPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports